import React from 'react';
import { clsx } from 'clsx';
import styles from './Card.module.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  hoverable?: boolean;
}

export function Card({
  children,
  className,
  padding = 'md',
  title,
  subtitle,
  action,
  hoverable = false,
}: CardProps) {
  return (
    <div className={clsx(styles.card, styles[`padding-${padding}`], hoverable && styles.hoverable, className)}>
      {(title || action) && (
        <div className={styles.header}>
          <div>
            {title && <h3 className={styles.title}>{title}</h3>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
          {action && <div className={styles.action}>{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
